import Colors from 'components/tokens/Colors';
import { Container, Row, Col } from 'components/atoms/Grid';
import Text from 'components/atoms/Text';
import NewsletterForm from './NewsletterForm';
import styled from 'styled-components';
import { sbEditable } from '@storyblok/storyblok-editable';

export default function Newsletter(props) {
    return (
        <StyledContainer fluid px="0" {...sbEditable(props)}>
            <Container px="1 5">
                <Row>
                    <Col size="12" mb="5" mt="5" px="1 0">
                        <Row justifyContent="space-between" alignItems="center">
                            <Col size="12 5" mb="3 0" px="1.5">
                                <Text heading5>{props?.title}</Text>
                            </Col>
                            <Col size="12 6" pr="1 0">
                                <NewsletterForm />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </StyledContainer>
    );
}

const StyledContainer = styled(Container)`
    background: ${Colors.white};
`;
